import React from 'react';
import { CTAButton } from './CTAButton';
import { BOX_IMAGE, CHECKOUT_URL } from '../data/atlas';
export function Hero() {
  return <section className="bg-navy px-4 py-6 text-center sm:py-8" data-id="element-80" data-mp="eibpbktviu8x">
      <div className="mx-auto max-w-3xl" data-id="element-81" data-mp="9ka2cotbuas6">
        <p className="mx-auto mb-3 inline-block rounded border border-teal/60 bg-teal/15 px-3 py-1 text-[10px] font-extrabold uppercase tracking-[0.18em] text-ice sm:text-xs" data-id="element-82" data-mp="9l357ep60g51">
          Dentures • RPDs • Fixed • Implants • Occlusion • Materials
        </p>

        <h1 className="text-3xl leading-[0.95] text-white sm:text-4xl md:text-5xl" data-id="element-83" data-mp="xa4gratao7ej">
          The Complete Visual Study System
          <span className="block text-teal" data-id="element-84" data-mp="s9q75oc1opee"> for Dental Students</span>
        </h1>

        <p className="mx-auto mt-3 max-w-2xl text-sm font-medium leading-snug text-ice sm:text-base" data-id="element-85" data-mp="nb6mdr96tjnm">
          Stop wasting hours jumping between textbooks, lecture notes and scattered
          resources trying to make sense of Prosthodontics. Get visual maps, clear
          comparisons, component guides, clinical workflow overviews and structured revision
          resources — all in one professional study system.
        </p>

        <a href={CHECKOUT_URL} className="mt-4 block" data-id="element-86" data-mp="3o5j41cky9nmv">
          <img src={BOX_IMAGE} alt="PROSTHODONTICS VISUAL ATLAS™ complete 6-in-1 module box set" className="mx-auto w-full max-w-xs drop-shadow-2xl transition-transform duration-200 ease-soft hover:scale-[1.02] sm:max-w-sm" data-id="element-87" data-mp="39b4knaxh4c7o" />
        </a>

        <CTAButton className="mx-auto mt-4 max-w-md" data-id="element-88" data-mp="3599jq7jgg0uf">
          🦷 YES! I WANT THE COMPLETE SYSTEM
        </CTAButton>

        <p className="mt-2 text-xs font-bold text-ice sm:text-sm" data-id="element-89" data-mp="2qkwiav1llpsj">
          🛡️ 14-Day Money-Back Guarantee
        </p>
      </div>
    </section>;
}